module.exports = __webpack_public_path__ + "static/media/2_ei-nalkaa_en_US.dbb2cbee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/2_ei-nalkaa_en_US.svg
// module id = ./src/images/agendaIcons/2_ei-nalkaa_en_US.svg
// module chunks = 1